// extracted by mini-css-extract-plugin
export default {"wrapper":"h0OP","disabled":"sR_f","checkmark":"PsQ7","checkbox":"w1s9","indeterminate":"_Tm3","label":"Nim0","label-as-title":"coGF","labelAsTitle":"coGF"};